// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#header[data-v-61dd7a3d] {\n    background-color: var(--darker-gray);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n#logo[data-v-61dd7a3d] {\n    height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
